import React, { Component } from "react";
import Form from "../components/Form/Form";
import templates from "../components/FormTemplates";
import dynamicPortal from "../utils/dynamicPortal";
import connection from "../api/config/connection";

import moment from "moment";
import "moment/locale/nl";
import "moment/locale/en-gb";
import "moment/locale/de";

export class CheckoutFormPortal extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
  }

  shouldComponentUpdate() {
    return false;
  }

  componentDidMount() {
    if (this.loading) {
      //if data is loaded from session storage, convert the value format back to display value
      const dateElement = document.getElementById("TravelDate");
      if (dateElement) {
        const momentValue = moment(dateElement.innerText, this.valueFormat);
        if (momentValue.isValid()) {
          dateElement.innerText = momentValue.format(this.displayFormat);
        }
      }

      this.reloadFullName();
      this.loading = false;
    }
  }

  calculateTotalPrice(quantity) {
    let totalPrice =
      parseInt(quantity) * parseFloat(this.price.replace(",", "."));
    totalPrice = totalPrice.toLocaleString(this.language, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    totalPrice = " € " + totalPrice;
    return totalPrice.replace(",00", ",-");
  }

  render() {
    return dynamicPortal.load(".js-react-checkout-form", (config) => {
      this.gender = config.gender || "";
      this.surname = config.surname || "";
      this.initials = config.initials || "";
      this.prefix = config.prefix || "";
      this.valueFormat = config.valueFormat;
      this.displayFormat = config.displayFormat;
      this.loading = true;
      this.price = config.price;
      this.language = config.language;

      return (
        <Form
          ref={this.formRef}
          config={config}
          templates={templates}
          axios={connection.instance()}
          onChange={(name, value) => this.handleChange(name, value)}
        />
      );
    });
  }

  async handleChange(name, value) {
    switch (name) {
      case "Quantity":
        document.getElementById("Amount").innerText = value;
        document.getElementById("OrderAmount").innerText =
          this.calculateTotalPrice(value);
        return;
      case "Email":
        document.getElementById("EmailAddress").innerHTML = value.replace(
          "@",
          "<wbr>@"
        );
        return;
      case "ingangsdatum":
        document.getElementById("TravelDate").innerText =
          value === undefined ? "" : value;
        return;

      case "Aanhef":
        this.gender = value;
        break;
      case "Achternaam":
        this.surname = value;
        break;
      case "Initialen":
        this.initials = value;
        break;
      case "Tussenvoegsel":
        this.prefix = value;
        break;

      default:
        return;
    }
    this.reloadFullName();
  }

  reloadFullName() {
    document.getElementById("FullName").innerText =
      (this.gender && this.gender + " ") +
        (this.initials + " ") +
        (this.prefix && this.prefix + " ") +
        this.surname || "";
  }
}

export default CheckoutFormPortal;



// WEBPACK FOOTER //
// ./src/portals/CheckoutFormPortal.js